import { render } from "./IntroSchoolFlooding.vue?vue&type=template&id=3fb313b3"
import script from "./IntroSchoolFlooding.vue?vue&type=script&lang=js"
export * from "./IntroSchoolFlooding.vue?vue&type=script&lang=js"

import "./IntroSchoolFlooding.vue?vue&type=style&index=0&id=3fb313b3&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__